import { defineMessages } from "react-intl";

const messages = defineMessages({
    gallery: {
        id: "choir.galery",
    },
    apply: {
        id: "choir.form.apply",
    },
});

export default messages;
